import React, { useEffect, useState } from "react";
import { GeoJSON } from "react-leaflet";

export const GeoJSONLayer = ({ data, ...geoJSONProps }) => {
  const [geoJSONData, setGeoJSONData] = useState(null);

  const onEachFeature = (feature, layer) => {
    if (feature.properties) {
      layer.bindPopup(
        Object.keys(feature.properties)
          .map(function (k) {
            return k + ": " + feature.properties[k];
          })
          .join("<br />"),
        {
          maxHeight: 200,
        }
      );
    }
  };

  useEffect(() => {
    const fetchGeoData = async () => {
      fetch(data?.url)
        .then((res) => res.json())
        .then((json) => {
          setGeoJSONData(json);
        })
        .catch((error) => {});
    };
    data?.url && fetchGeoData();
  }, [data?.url]);

  if (geoJSONData) {
    return (
      <GeoJSON
        key={Math.random()}
        data={geoJSONData}
        onEachFeature={onEachFeature}
        {...geoJSONProps}
      />
    );
  }

  return null;
};
